function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1725 1898",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3885.84,-9850.39)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4748.03,
    cy: 10795.3,
    r: 826.772,
    style: {
      fill: "white",
      stroke: "rgb(132,245,212)",
      strokeWidth: "70.83px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8,0,0,0.8,949.606,2159.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4748.03,
    cy: 10795.3,
    r: 826.772,
    style: {
      fill: "rgb(109,255,239)"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4346.46,
    cy: 10027.6,
    rx: 188.976,
    ry: 177.165,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-236.22,141.732)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4346.46,
    cy: 10027.6,
    rx: 188.976,
    ry: 177.165,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5385.83,11102.4L5055.12,11433.1L5574.8,11716.5L5385.83,11102.4Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11111,0,0,0.944444,-603.675,664.042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5007.87,11291.3L5433.07,11527.6L5305.51,11002.3L5007.87,11291.3Z",
    style: {
      fill: "rgb(109,255,239)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8125,0,0,0.75,1570.87,2692.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3118.14,9665.08C3122.08,9661.88 3128.24,9657.88 3136.61,9653.08C3144.98,9648.28 3154.33,9643.22 3164.67,9637.88C3175.01,9632.55 3185.59,9628.02 3196.42,9624.28C3207.25,9620.55 3216.61,9618.68 3224.48,9618.68C3244.18,9618.68 3256.24,9623.48 3260.67,9633.08C3265.1,9642.68 3267.81,9659.22 3268.79,9682.68C3270.76,9723.22 3270.51,9766.42 3268.05,9812.28C3265.59,9858.15 3260.42,9899.75 3252.55,9937.08C3244.67,9971.22 3233.59,9998.68 3219.31,10019.5C3205.04,10040.3 3192.98,10050.7 3183.13,10050.7C3177.22,10050.7 3172.3,10047.2 3168.36,10040.3C3164.42,10033.4 3161.22,10024.8 3158.76,10014.7C3156.3,10004.6 3154.58,9993.35 3153.59,9981.08C3152.61,9968.82 3152.11,9957.35 3152.11,9946.68C3152.11,9892.28 3148.67,9845.35 3141.78,9805.88C3134.88,9766.42 3123.07,9739.75 3106.33,9725.88C3094.51,9715.22 3091.07,9704.28 3095.99,9693.08C3100.91,9681.88 3108.3,9672.55 3118.14,9665.08ZM3332.3,9655.48C3332.3,9649.08 3336.48,9643.48 3344.85,9638.68C3353.22,9633.88 3363.31,9629.35 3375.13,9625.08C3386.95,9620.82 3398.76,9617.62 3410.58,9615.48C3422.39,9613.35 3432.24,9611.75 3440.11,9610.68C3459.81,9608.55 3473.59,9610.95 3481.47,9617.88C3489.35,9624.82 3494.76,9638.95 3497.71,9660.28C3500.67,9681.62 3501.65,9706.15 3500.67,9733.88C3499.68,9761.62 3497.96,9789.62 3495.5,9817.88C3493.04,9846.15 3489.59,9873.35 3485.16,9899.48C3480.73,9925.62 3476.55,9947.22 3472.61,9964.28C3469.65,9974.95 3465.22,9985.88 3459.31,9997.08C3453.41,10008.3 3446.76,10018.4 3439.38,10027.5C3431.99,10036.6 3424.36,10043.5 3416.48,10048.3C3408.61,10053.1 3401.71,10055 3395.81,10053.9C3388.91,10052.8 3383.74,10043.2 3380.3,10025.1C3376.85,10007 3374.64,9985.62 3373.65,9961.08C3372.67,9937.62 3371.93,9915.48 3371.44,9894.68C3370.95,9873.88 3370.21,9853.88 3369.22,9834.68C3368.24,9815.48 3366.76,9796.28 3364.79,9777.08C3362.82,9757.88 3360.36,9737.62 3357.41,9716.28C3355.44,9704.55 3350.76,9694.42 3343.38,9685.88C3335.99,9677.35 3332.3,9667.22 3332.3,9655.48Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5149.32,11513.4L5574.8,11716.5L5450.19,11224.7",
    style: {
      fill: "none",
      stroke: "rgb(132,245,212)",
      strokeWidth: "62.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitation);
export default __webpack_public_path__ + "static/media/citation.f72de9530c2953ffa670e886f38c159e.svg";
export { ForwardRef as ReactComponent };